// src/pages/Admin/CoursAgenda/data/coursAgendaUi.js

export const COURSE_ACCENT_COLORS = [
  "#2563eb",
  "#e11d48",
  "#059669",
  "#d97706",
  "#7c3aed",
  "#0891b2",
  "#65a30d",
  "#dc2626",
  "#9333ea",
  "#0f766e",
];

export const getInstructorAccentColor = (instructorId) => {
  if (!instructorId) {
    return "#64748b";
  }

  const index =
    Math.abs(Number(instructorId)) % COURSE_ACCENT_COLORS.length;

  return COURSE_ACCENT_COLORS[index];
};